import { IPrismicCarouselProductsPrimary } from './types';
import { IPrismicCustomTypeContent } from '../../prismicTypes';
import { IAlgoliaSearchProductsResponse } from '@monofront/business/services';
import { productService } from '@services/businessContainer';
import { Channel } from '@monofront/business/constants';
import getConfig from 'next/config';
import { OneTrustCookieCategories } from '@components/Vendors/Vendors';
import getCookieConsent from '@utils/getCookieConsent';

const {
  publicRuntimeConfig: { algoliaConfig },
} = getConfig();

interface IFetchProductsOptions {
  hitsPerPage?: number;
}

export const fetchProductsByPopularity = async (
  handle: string,
  channel: Channel = Channel.FR,
  options?: IFetchProductsOptions,
  userId?: string,
) => {
  const { hits: products }: IAlgoliaSearchProductsResponse =
    await productService.getProductsByPopularity({
      channel,
      filters: `collections:"${handle}"`,
      hitsPerPage: options?.hitsPerPage || 20,
      ruleContexts: ['carousel_v2', handle, `carousel-${handle}`],
      userToken: getCookieConsent(OneTrustCookieCategories.FUNCTIONALITY)
        ? userId
        : undefined,
      // This "disable-fresh" context cannot be determined by the user context as it occures in the backend
      // It should be checked after the POC phase
    });

  return products;
};

export const getPageContentsWithProducts = async (
  pageContents: IPrismicCustomTypeContent[],
  channel: Channel = Channel.FR,
  userId?: string,
): Promise<IPrismicCustomTypeContent[]> => {
  const pageContentsWithProducts = await Promise.all(
    pageContents.map(async (content: IPrismicCustomTypeContent) => {
      if (
        content.slice_type === 'products_carousel' ||
        content.slice_type === 'carousel_fresh_products' ||
        content.slice_type === 'ProductsCarousel' ||
        content.slice_type === 'CarouselFreshProducts'
      ) {
        const {
          collection: { handle },
        }: IPrismicCarouselProductsPrimary =
          content.primary as IPrismicCarouselProductsPrimary;

        const products = await fetchProductsByPopularity(
          handle,
          channel,
          undefined,
          userId,
        );

        return {
          ...content,
          items: products,
        };
      }

      if (
        (content.slice_type === 'multiple_products_carousels' ||
          content.slice_type === 'MultipleProductsCarousels') &&
        content.items?.length
      ) {
        const itemsWithProducts = await Promise.all(
          content.items.map(async (item) => {
            const handle =
              algoliaConfig.environment === 'production'
                ? item.collection?.handle
                : item.collection_preprod?.handle;

            const algoliaProducts = await fetchProductsByPopularity(
              handle,
              channel,
              { hitsPerPage: 15 },
            );

            return {
              ...item,
              algoliaProducts,
            };
          }),
        );

        return {
          ...content,
          items: itemsWithProducts,
        };
      }

      return content;
    }, []),
  );

  return pageContentsWithProducts;
};
